export const LOADING = "LOADING";
export const IMPORTED_LEADS = "IMPORTED_LEADS";
export const IMPORT_SUMMARY = "IMPORT_SUMMARY";
export const SELECTED_RECORDS = "SELECTED_RECORDS";
